// Preferencias de APARIENCIA por usuario (fuente y tamaño), guardadas en el
// navegador (localStorage) y aplicadas al instante sobre <html>. No necesitan
// backend: son preferencia local de cada persona/dispositivo.
//   - fuente: "public" (predeterminada del sistema de diseño) | "jakarta" | "inter"
//     → atributo data-font en <html>
//   - tamaño: px del font-size raíz (escala TODO proporcionalmente, rem-based)
const FONT_KEY = "tf_font";
const SIZE_KEY = "tf_fontsize";
const SIZE_VERSION_KEY = "tf_fontsize_v2";
const COLOR_KEY = "tf_color_scheme";
const NAV_LAYOUT_KEY = "tf_nav_layout";
const SIDEBAR_COLLAPSED_KEY = "tf_sidebar_collapsed";

const userKey = (base, userId) => `${base}_${userId || "guest"}`;

// La navegación clásica (standard) es la experiencia por defecto, para no
// impactar a los usuarios habituales. Quien quiera probar el diseño ERP (menú
// vertical) lo activa desde Perfil → Personalización; la elección queda guardada.
export const getNavLayout = (userId) => localStorage.getItem(userKey(NAV_LAYOUT_KEY, userId)) || "standard";
export function setNavLayout(userId, layout) {
  const safeLayout = layout === "erp" ? "erp" : "standard";
  localStorage.setItem(userKey(NAV_LAYOUT_KEY, userId), safeLayout);
  window.dispatchEvent(new CustomEvent("tf:nav-layout-change", { detail: { userId, layout: safeLayout } }));
}

export const getSidebarCollapsed = (userId) => localStorage.getItem(userKey(SIDEBAR_COLLAPSED_KEY, userId)) === "true";
export function setSidebarCollapsed(userId, collapsed) {
  localStorage.setItem(userKey(SIDEBAR_COLLAPSED_KEY, userId), String(Boolean(collapsed)));
}

export const FUENTES = [
  { key: "public", label: "Public Sans", muestra: "'Public Sans', sans-serif" },
  { key: "jakarta", label: "Plus Jakarta Sans", muestra: "'Plus Jakarta Sans', sans-serif" },
  { key: "inter", label: "Inter", muestra: "'Inter', sans-serif" },
];
export const TAMANOS = [
  { key: "13", label: "Compacto" },
  { key: "14", label: "Pequeño" },
  { key: "15", label: "Normal" },
  { key: "16", label: "Cómodo" },
];

export const ESQUEMAS_COLOR = [
  { key: "clasico", label: "Claro clásico", area: "#F7F8FA", menu: "#FFFFFF" },
  { key: "azul", label: "Azul suave", area: "#EEF3FA", menu: "#F8FAFD" },
  { key: "gris", label: "Gris profesional", area: "#EEF0F3", menu: "#F8F9FB" },
];

export const getFuente = () => localStorage.getItem(FONT_KEY) || "public";
export function getTamano() {
  const saved = localStorage.getItem(SIZE_KEY);
  if (!localStorage.getItem(SIZE_VERSION_KEY)) {
    const legacySizes = { "15": "13", "16": "14", "17": "15", "18": "16" };
    if (saved && legacySizes[saved]) localStorage.setItem(SIZE_KEY, legacySizes[saved]);
    localStorage.setItem(SIZE_VERSION_KEY, "1");
  }
  const current = localStorage.getItem(SIZE_KEY);
  return TAMANOS.some((size) => size.key === current) ? current : "14";
}
export const getEsquemaColor = () => ESQUEMAS_COLOR.some((c) => c.key === localStorage.getItem(COLOR_KEY)) ? localStorage.getItem(COLOR_KEY) : "clasico";
export function aplicarApariencia() {
  const f = getFuente();
  document.documentElement.setAttribute("data-font", f);
  const s = getTamano();
  document.documentElement.style.fontSize = `${s}px`;
  const esquema = ESQUEMAS_COLOR.find((c) => c.key === getEsquemaColor()) || ESQUEMAS_COLOR[0];
  document.documentElement.style.setProperty("--tf-workspace-bg", esquema.area);
  document.documentElement.style.setProperty("--tf-sidebar-bg", esquema.menu);
}

export function setFuente(f) {
  localStorage.setItem(FONT_KEY, f);
  aplicarApariencia();
}
export function setTamano(s) {
  localStorage.setItem(SIZE_KEY, s);
  localStorage.setItem(SIZE_VERSION_KEY, "1");
  aplicarApariencia();
}
export function setEsquemaColor(s) {
  const safeScheme = ESQUEMAS_COLOR.some((c) => c.key === s) ? s : "clasico";
  localStorage.setItem(COLOR_KEY, safeScheme);
  aplicarApariencia();
}
